import './fund_base.js'
import { initSpRankingHeader, fixedSpRankingHeader } from './ranking_common.js'

$(function(){
    if ($('#rankingList table tr td.bg_light_blue').length > 1) {
        $('body').addClass('show_compare');
    }

    $('.workshops_timeList li').on('click',function(){
        if ($('.loading').length > 0) return;
        if (!$(this).hasClass('active')) {
            $(this).addClass('active').siblings().removeClass('active');
            var term = $(this).attr('data-value');

          var rankingObj = $('#rankingList');
          loading.append(rankingObj);

          var url = '/top/ranking/' + term;
          $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            contentType: false,
            processData: false,
            success: function(data){
              loading.remove();
              if (data.indexOf('compare_table') != -1) {
                if (rankingObj) rankingObj.html(data);
              }
              else {
                showError("エラーが発生しました");
              }
            },
            error: function(data){
              loading.remove();
              showError("エラーが発生しました");
            }})

        }
    });

    if(window.location.href.indexOf("ranking/fund_view") > 0){
      $('.compare_table_select_list,.compare_table_list_select').hide();
      $('.comm_ranking_list li').eq(1).hide();
      $('.comm_ranking_list li:last-child').addClass('comm-ranking-fr');
      $('.pageCon_rankings .compare_table tbody tr td:nth-child(4)').addClass('text-center');
    }

    if($("body").hasClass("sp_body")){
      if(window.location.href.indexOf("ranking/fund_view") > 0){
        $('.pageCon_rankings .sp_compare_table tbody tr:odd td:nth-child(2)').addClass('text-center');
      }
    }

    if($('#user_status').length > 0) {
        var userSts = $('#user_status').attr('date-user_status_flg');

        $('.stock_tabs_wrapper span').on('click', function(){
            if(window.location.href.indexOf('surge') > -1 || window.location.href.indexOf('newly_established') > -1) {
                if (userSts == "premium") {
                    $(this).addClass('on').siblings().removeClass('on');
                } else {
                    return false;
                }
            } else {
                $(this).addClass('on').siblings().removeClass('on');
            }
        });
    }

    $('.period_select span').on('click', function(){
        $(this).addClass('on').siblings().removeClass('on');
    });

    if($('body').hasClass('sp_body')) {
        var leftW = $('.ranking_list .ranking_table table.md_table tr td:first-child').outerWidth();
        $('.ranking_list .ranking_table table.md_table tr td:nth-child(2)').css('left',(leftW - 0.41) + 'px');
    }

    if(window.location.href.indexOf("ranking/foreign_linkage_ranking") > 0 || window.location.href.indexOf("ranking/crude_linkage_ranking") > 0){
        $('#rankingList').addClass('linkage_ranking');
    }

    if($('body').hasClass('sp_body')) {
      if(window.location.href.indexOf("ranking/total_dividend") > 0){
        $('#rankingList').addClass('dividend_ranking');
      }
    }

    $(document).on('click', '#rankingList .pagination li', function () {
        if (!$(this).hasClass('disabled') && !$(this).hasClass('active')) {
            loading.append($('.ranking_table'));
            $(window).scrollTop(0);
            $('.pagination').html('');
        }
    })
    //ranking/yield_nisa
    if (window.location.href.indexOf('ranking/yield_nisa') > -1) {
      if ($('body').hasClass('sp_body')) {
        $('.ranking_condition_wrapper').addClass('posrlt');
        $('.ranking_condition_wrapper .ranking_select:first-child').addClass('ranking_nisa_time');
        $('.ranking_condition_wrapper .ranking_select:nth-child(2) .total_num').addClass('ranking_nisa_total');
      }
    }
    //ranking/recommend_nisa
    if (window.location.href.indexOf('ranking/recommend_nisa') > -1) {
      if ($('body').hasClass('sp_body')) {
        $('.ranking_condition_wrapper .ranking_select:nth-child(2) .total_num').addClass('ranking_recommend_total');
      }
    }

    initTabsPosition();
    initFundRankingFavorite();
    initSpRankingHeader();
});

// All window scroll trigger event
$(window).scroll(function(){
  fixedSpRankingHeader();
});

// load ranking data
// opt.more: load more data
// opt.limit: load limit data of once
function loadRankingData(opt) {
//    console.log('opt', opt);
    if (opt == undefined || opt == null) opt = {};
    if (opt.more == undefined || opt.more == null) opt.more = false;
    // class (large, middle, small)

    var action = $('#ranking_action').val();
    var url = '/ranking/' + action;

    // limit
    var limit = 30;
    if (opt.limit != undefined && opt.limit != null) {
        limit = opt.limit;
    }
    else if ($('#ranking_limit').length > 0) {
        limit = $('#ranking_limit').val();
    }

    // term
    var term = 0;
    if (opt.term != undefined && opt.term != null) {
        term = opt.term;
    }
    else {
        term = $('#rankingTermList').val();
        if (term == undefined) term = $('#ranking_term').val();
    }

    // index_id
    var index_id = $('#rankingIndexId').val();
    if (index_id != undefined) {
        // sort
        var soukan = $('#rankingSort').val();
        url = url + '?limit=' + limit;
        url = url + '&index_id=' + index_id;
        url = url + '&soukan=' + soukan;
        url = url + '&term=' + term;

    }
    else {
        var large_class = $('#rankingLargeClassList').val() || 0;
        var middle_class = $('#rankingMiddleClassList').val() || 0;
        var small_class = $('#rankingSmallClassList').val() || 0;
        var ranking_class = $('#rankingClass').val() || '';

        var params = new Array();
        if (large_class != undefined) params.push(large_class);
        if (middle_class != undefined) params.push(middle_class);
        if (small_class != undefined) params.push(small_class);
        if (term != undefined) params.push(term);
        url = url + '/' + params.join('/');
        url = url + '?limit=' + limit;
        url = url + '&class=' + ranking_class;
    }

    // parent_url
    if (opt.parent_url != undefined && opt.parent_url != null) {
        url = url + '&parent_url=' + opt.parent_url;
    }
    else if ($('#parent_url').length > 0) {
        url = url + '&parent_url=' + $('#parent_url').val();
    }

    // page
    var page = 1;
    if (opt.more && $('#ranking_page').length > 0) {
        page = parseInt($('#ranking_page').val()) + 1;
        if (page > parseInt($('#total_pages').val())) return;
    }
    url = url + '&page=' + page;

    var rankingObj;
    if ($('#rankingList').length > 0) rankingObj = $('#rankingList');
    if (opt.more) {
        loading.append($('#loading_more td'));
    }
    else {
        loading.append(rankingObj);
    }

    $.ajax({
        url: url,
        type: 'GET',
        cache: false,
        contentType: false,
        processData: false,
        success: function(data){
            loading.remove();
            var push_state_flag = false;
            if (data.indexOf('compare_table') != -1) {
                if (rankingObj) rankingObj.html(data);
                $('#ranking_page').val(1);
                if (rankingObj.hasClass('ranking')) push_state_flag = true;
            }
            else if (opt.more) {
                if (rankingObj) {
                    var body = rankingObj.find('tbody').html();
                    rankingObj.find('tbody').html(body + data);
                    if (rankingObj.hasClass('ranking')) push_state_flag = true;
                }

                if (page != null) {
                    $('#ranking_page').val(page);
                    if (page >= parseInt($('#total_pages').val())) {
                        $('#loading_more').hide();
                    }
                }
            }
            else {
                showError("エラーが発生しました");
            }
            if(window.location.href.indexOf("ranking/fund_view") > 0){
              $('.pageCon_rankings .compare_table tbody tr td:nth-child(4)').addClass('text-center');
            }
            if($("body").hasClass("sp_body")){
              if(window.location.href.indexOf("ranking/fund_view") > 0){
                $('.pageCon_rankings .sp_compare_table tbody tr:odd td:nth-child(2)').addClass('text-center');
              }
            }

            if (push_state_flag) {
                saveStorageRankingList(rankingObj.html());
            }
        },
        error: function(data){
            loading.remove();
            showError("エラーが発生しました");
        }})
}

// loading when ranking changed.
function loadingRankingChange(obj, t) {
    let _time = t || 800;
    setTimeout(function(){
        if (obj == undefined) obj = $('.ranking_table');
        loading.append(obj);
        $('.pagination').html('');
    }, _time);
}

// ranking condition select event.
function rankingSelect(obj){
    loadingRankingChange($('.ranking_table'), 300);

    let action = $('#ranking_category').val();
    let condition_list = $('#ranking_condition_list').val();
    let url = '/ranking/' + action;
    let params = []; // Condition params

    // condition: fund_type (level2)
    if (condition_list.indexOf('fund_type') != -1) {
        let fundType = $('.fund_type_item.on').attr('data-value') || '';
        if (fundType != '') params.push('fund_type=' + fundType);
    }

    // condition: period (weekly / monthly)
    if (condition_list.indexOf('period') != -1) {
        // Change the class for js to collect value.
        if ($(obj).hasClass('period_item')) {
            $('.period_item').removeClass('on');
            $(obj).addClass('on');
        }
        let popularPeriod = $('.period_item.on').attr('data-value') || '7';
        if (popularPeriod != '7') params.push('period=' + popularPeriod);
    }

    // condition: region
    if (condition_list.indexOf('region') != -1) {
        let popularRegion = $('#rankingRegionList').val() || '';
        if (popularRegion != '') params.push('region=' + popularRegion);
    }

    // condition: fund_times
    if (condition_list.indexOf('fund_times') != -1) {
        let fundTimesList = [];
        // Change the class for js to collect value.
        if ($(obj).hasClass('fund_time_item')) {
            if ($(obj).hasClass('on')) {$(obj).removeClass('on')} else {$(obj).addClass('on')};
        }
        $('.fund_time_item.on').each(function () {
            fundTimesList.push($(this).attr('data-value'))
        });
        if (fundTimesList.length > 0) {
            params.push('fund_times=' + fundTimesList.join(','));
        }
    }

    // condition: soukan
    if (condition_list.indexOf('soukan') != -1) {
        let soukan = $('#rankingSoukan').val() || 0;
        if (soukan != 0) params.push('soukan=' + soukan);
    }

    // condition: exchange
    if (condition_list.indexOf('exchange') != -1) {
        let exchange = $('#rankingExchangeList').val() || 0;
        if (exchange != 0) params.push('exchange=' + exchange);
    }

    // condition: term
    if (condition_list.indexOf('term') != -1) {
        let term = $('#rankingTermList').val() || 12;
        if (term != 12) params.push('term=' + term);
    }

    if (params.length > 0) url += '?' + params.join('&');
    window.location.href = url;
}

//position new_type_tabs
function initTabsPosition() {
    var Tabs = $('.new_type_tabs');
    //var screenWidth = $('.sp_body').width();
    if ($('body').hasClass('sp_body')) {
      var screenWidth = $('.sp_body').width();
    } else {
      var screenWidth = $('.pageCon_rankings,.pageCon_top').width();
    }
    var curTab = Tabs.find('li.cur');
    var curTabWidth = curTab.width();
    var halfCurTabWidth = curTabWidth/2;
    var halfScreenWidth = screenWidth/2;
    if(curTab.length > 0){
        var postionLeft = curTab.position().left;
        var moveX = postionLeft + Tabs.scrollLeft();
        var left = moveX - halfScreenWidth + halfCurTabWidth;
        Tabs.scrollLeft(left);
    }
}

// Initialization fund favorite status on ranking page.
function initFundRankingFavorite() {
    var blankHeartClass = 'icon-heart-regular favorite_grey';
    var solidHeartClass = 'icon-heart-solid favorite_red';
    var fundList = []
    var cookieFundList = $.cookie('favorite_fund_list');
    var cookieUserId = $.cookie('user_id');
    // Clear favorites on logout.
    if (cookieUserId == null || cookieUserId == '') {
        $.removeCookie('favorite_fund_list');
        return;
    }

    if (cookieFundList != null) {
        if (cookieFundList.indexOf('&') != -1) {
            fundList = cookieFundList.split('&');
        }
        else {
            if (cookieFundList != '') {
                fundList = [cookieFundList];
            }
        }
    }
    if (fundList.length == 0) {
        return;
    }
    $('.ranking_heart span').each( function() {
        var fund_id = $(this).parents('tr').data('id-fund');
        if (fund_id != null) {
            if (fundList.includes(fund_id.toString()) && !$(this).hasClass(solidHeartClass)) {
                $(this).addClass(solidHeartClass);
                $(this).removeClass(blankHeartClass);
            }
            else if(!fundList.includes(fund_id.toString()) && $(this).hasClass(solidHeartClass)) {
                $(this).addClass(blankHeartClass);
                $(this).removeClass(solidHeartClass);
            }

            if (!$(this).hasClass("heart_span_"+fund_id)) {
                $(this).addClass("heart_span_"+fund_id);
            }
        }
    })
}

// Favorite fund for ranking page.
function favoriteFundForRanking(obj, fundId) {
    var favorite_span = $('.favorite_span_'+fundId);
    favoriteFund({
        fundId: fundId,
        objChangeFunc: function (data) {
            var status = parseInt(data.status);
            if (status == 1) {
                $('.heart_span_'+data.fund_id).removeClass('icon-heart-regular favorite_grey').addClass('icon-heart-solid favorite_red');
                favorite_span.addClass("active");
                favorite_span.find('i.colllect_icon').removeClass('fa fa-star-o').addClass("icon-star-full");
            } else if (status == 2) {
                $('.heart_span_'+data.fund_id).removeClass('icon-heart-solid favorite_red').addClass('icon-heart-regular favorite_grey');
                favorite_span.removeClass("active");
                favorite_span.find('i.colllect_icon').addClass('fa fa-star-o').removeClass("icon-star-full");
            }
        }
    })
}